// Action enums
export enum ActionTypes {
  SET_PROJECT_TYPES = "SET_PROJECT_TYPES",
  SET_PROJECT_INITIAL_TYPES = "SET_PROJECT_INITIAL_TYPES",
  SET_MANUAL_STAGES = "SET_MANUAL_STAGES",
  SET_BALLOT_STAGES = "SET_BALLOT_STAGES",
}
